/* Rippin Moto redesign. "Set as my bike" button on sections/rm-bike-hero.liquid.
   Writes localStorage.rm_bike and dispatches rm:bike-change so any other rm-*
   component (header bike picker, builder, PDP) on this or a later page can react.
   Vanilla JS, no dependency on Savor's cart JS. */
(function () {
  'use strict';

  function setBike(handle, name) {
    try {
      window.localStorage.setItem('rm_bike', handle);
    } catch (e) {
      /* localStorage unavailable (private mode, disabled storage); continue without persistence */
    }
    document.dispatchEvent(
      new CustomEvent('rm:bike-change', {
        detail: { bike: handle, handle: handle, label: name || handle, name: name || handle },
      })
    );
  }

  function currentBike() {
    try {
      return window.localStorage.getItem('rm_bike');
    } catch (e) {
      return null;
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-rm-set-bike]');
    if (!button) return;
    var handle = button.getAttribute('data-bike-handle');
    var name = button.getAttribute('data-bike-name');
    if (!handle) return;
    setBike(handle, name);
    button.setAttribute('data-set', 'true');
    var original = button.textContent;
    button.textContent = 'Saved';
    setTimeout(function () {
      button.textContent = original;
    }, 1800);
  });

  document.addEventListener('DOMContentLoaded', function () {
    var active = currentBike();
    if (!active) return;
    document.querySelectorAll('[data-rm-set-bike]').forEach(function (button) {
      if (button.getAttribute('data-bike-handle') === active) {
        button.setAttribute('data-set', 'true');
      }
    });
  });
})();
